/**
 *  使用 单个更新
 */
import React, { useState, } from 'react';
import { Row, Col, Input, } from 'antd';
import ImageHover from "../../Components/ImageHover";
import StickerTemplateSelector from "../../Components/StickerTemplateSelector";
import CertificateNew from '../../../CustomsDeclarationStickerManagement/StickerBrand/Certificate/CertificateNew.js';
import UploadImage from '@components/UploadFile/UploadImage/UploadImage';
import {isEmpty,isEmptyObject,trim,getFileSuffix,cloneObj} from '@utils/utils';
import Lang from "@components/Lang/Lang";
const { TextArea } = Input;
const config = require("@config/config");
const OneItem = (props) => {
    const {
        item = {},
        isEdit=false,
        isHadEdit=false,
        inx=0,
        isSubmit="",
        portalUrl = config.servers[config.environment].portalUrl,
        saveOther
    } = props;
    const [curChaObj, setCurChaObj,] = useState(cloneObj(item));
    // 属性列表
    const renderAttribute = (attributeList=[])=>{
        let childAtt = [];
        attributeList.forEach((att,inx)=>{
            if(att.optionList&&att.optionList.length>0){
                childAtt.push(<Col key={"at_"+inx} span={inx==0?6:12} className={'descItem'}>{att.attributeName}
                    {att.optionList.map((opt, suInx)=>(<span key={"at_"+inx+'_o-'+suInx}>{opt.optionName}</span>))}
                </Col>)
            }
        })
        return childAtt;
    }
    /**
     * 菜单
     * */
    const renderRow =(title="",required=false,content)=>{
        return (<div className={"flex-item mb_12"}>
            <div className={"leftW mr_8 black45"}>{title}{required?<span className={"star ml_2"}>*</span>:null}</div>
            <div className={"flex-1"}>
                {content}
            </div>
        </div>)
    }
    /**
     * 行编 e.target.value
     *
     * */
    const onChangeField=(value,field,e)=>{
        if(!isEdit) return;
        curChaObj[field] = value;
        if(field=='stickerItem'){
            curChaObj['stickerCode'] = value.stickerCode;
            curChaObj['newStickerList'] = [value];
        }
        if(field=='goodsCertificateList'){
            curChaObj['hasCertificate'] = value&&value.length>0?1:null;
            curChaObj['hasCertificateList'] = value&&value.length>0?1:null;
        }
        setCurChaObj({...curChaObj});
        saveOther(curChaObj)
        // if(!isHadEdit&&isEdit&&setHadEdit){
        //     setHadEdit(true);
        // }
    }
    curChaObj.disabled = isEdit?false:true;
    const required = (curChaObj.hasCertificate==1 || curChaObj.hasCertificate==2)?true:false;

    return (<div className={`itemLi${curChaObj.isTort==1?" itemLiTort":""}`} key={"itemLi_"+inx}>
        <div className={'pro'}>
            {/* 中国直达新增 isTort :1 商品侵权 */}
            {curChaObj.isTort==1?<span className={"labelTort"}>{Lang({id: 'ChanPinYiQinQuan', default: '产品已侵权'})}</span>:null}
            {curChaObj.skuPictureUrl&&<ImageHover src={curChaObj.skuPictureUrl} size={400} key={"img_"+inx} />}
        </div>
        <div className={'info'}>
            <div className='skuName'>
                {curChaObj.showEnTitle===1?<p className='skuName-line'>
                                <span className='skuName-translate-icon' onClick={()=>onChangeField(0,'showEnTitle')}>
                                EN
                                </span><a href={portalUrl+`/${curChaObj.goodsId}.html?skuNo=${curChaObj.skuNo}`} target={'_blank'}>{curChaObj.skuNameEn}</a>
                    </p>:<p className='skuName-line' onClick={()=>onChangeField(1, 'showEnTitle',true)}>
                                <span className='skuName-translate-icon'>
                                RU
                                </span><a href={portalUrl+`/${curChaObj.goodsId}.html?skuNo=${curChaObj.skuNo}`} target={'_blank'}>{curChaObj.skuNameRu}</a>
                    </p>}
            </div>
            <div className={'desc'}>
                <Row gutter={24}>
                    <Col span={6} className={'descItem'}>{Lang({id: 'ShangPinBianMa', default: '商品编码'})}<span>{curChaObj.skuNo}</span></Col>
                    <Col span={6} className={'descItem'}>{Lang({id: 'LeiMu', default: '类目'})}<span>{curChaObj.categoryName}</span></Col>
                    <Col span={12} className={'descItem'}>{Lang({id: 'CaiZhi', default: '材质'})}<span>{curChaObj.mainMaterials}</span></Col>
                    {/* <Col span={6} className={'descItem'}>{Lang({id: 'HaiGuanBianMa', default: '海关编码'})}<span>{curChaObj.customsCode}</span></Col> */}
                    {renderAttribute(curChaObj.attributeList)}
                </Row>
            </div>
            <div className={'cerSetBox'}>
                {/* 海关编码 */}
                {renderRow(Lang({id: 'HaiGuanBianMa', default: '海关编码'}),required,
                    isEdit?<div>
                            <div className={"flex-item"}>
                                <Input className={"essa-ant-input mr_12 mb_8"}
                                       style={{width:"200px"}}
                                       key={"sCustode_"+inx}
                                       // defaultValue={curChaObj.customsCode}
                                       value={curChaObj.customsCode}
                                       onChange={(e) =>{
                                           onChangeField(e.target.value, 'customsCode',);
                                       }}  />
                                    {/* 可点击赋值的海关编码列表 */}
                                    {curChaObj.customsCodeList&&curChaObj.customsCodeList.length>0?<>
                                                    {curChaObj.customsCodeList.map((sCusCode,inx)=><span className={"greyBtn"} key={"greyBtn_"+inx}
                                                                                    onClick={()=>onChangeField(sCusCode, 'customsCode')}>{sCusCode}</span>)}</>:null}
                            </div>
                            {/* 校验 */}
                            {(isSubmit==1&&required&&isEmpty(curChaObj.customsCode))||(!isEmpty(curChaObj.customsCode)&&curChaObj.customsCode.length!==10)?<div className={"color-err"}>
                                {Lang({id: 'QingShuRuHaiGuanBianMa', default: '请输入十位数的海关编码'})}
                            </div>:null}
                    </div>:curChaObj.customsCode,
                )}

                {/* 商品证书 在此屏蔽无证书 及 目前改为不可编辑 */}
                {renderRow(Lang({id: 'ShangPinZhengShu', default: '商品证书'}),required,
                    <div>
                        <div className='CertificateType'>
                            {isEdit?<CertificateNew categoryId={curChaObj.topCategoryId}
                                                    callBack={(value=[]) =>onChangeField(value,'goodsCertificateList')}
                                                    goodsCertificateList={curChaObj.goodsCertificateList}>
                                                <span className={`CertificateType-option ${curChaObj.hasCertificate == 1?'cur':''}`}>{Lang({id: 'YouZhengShu', default: '有证书'})}
                                                    <span className="ri-edit-line" style={{float:'right'}}></span>
                                                </span>
                            </CertificateNew>:
                                <span className={`CertificateType-option ${curChaObj.hasCertificate == 1?'cur':''}`}
                                                    // onClick={(e) => {onChangeField(1, 'hasCertificate')}}
                                >
                                     {Lang({id: 'YouZhengShu', default: '有证书'})}
                                </span>
                            }
                                    {/*<span className={`CertificateType-option ${curChaObj.hasCertificate == 0?'cur':''}`}*/}
                                          {/*onClick={(e) => {onChangeField(0,'hasCertificate')}}*/}
                                    {/*>*/}
                                                    {/*{Lang({id: 'WuZhengShu', default: '无证书'})}*/}
                                    {/*</span>*/}
                                <span className={`CertificateType-option ${curChaObj.hasCertificate == 2?'cur':''}`}
                                      onClick={(e) => {onChangeField(2,'hasCertificate')}}
                                >
                                      {Lang({id: 'WuZhengShuChuHuo', default: '无证书出货'})}
                                </span>
                        </div>
                        {(isEmpty(curChaObj.hasCertificate)||curChaObj.hasCertificate===1)&&curChaObj.hasCertificateList === 1?<div
                            className='CertificateList mt_8 mb_8'>
                            {curChaObj.goodsCertificateList && curChaObj.goodsCertificateList.map((value,cerInx) => {
                                return <span className='CertificateItem' key={"cer_"+cerInx}>
                                                            {value.code}
                                                        </span>
                            })}
                        </div>:null}
                        {/* 证书 或 备注 start */}
                        {curChaObj.hasCertificate==1&&(curChaObj.certificateCode||curChaObj.remark?<div className={'cerShow'}>
                                {curChaObj.certificateCode&&<p>
                                    {Lang({id: 'certificateEncoding', default: '证书编码'})}
                                    <span>{curChaObj.certificateCode}</span>
                                </p>}
                                {curChaObj.hasRemark&&<p>
                                    {Lang({id: 'BeiZhu', default: '备注'})}<span>{curChaObj.hasRemark}</span>
                                </p>}
                            </div>:null)}
                        {/* 证书 或 备注 end */}
                        {/* 请填写无证书说明 出现时必填  */}
                        {curChaObj.hasCertificate==0?<div className={"mt_8"}>
                            <TextArea placeholder={Lang({id: 'QingTianXieWuZhengShuShuoMing', default: '请填写无证书说明'})}
                                                          key={'remark_'+inx}
                                                          value={curChaObj.remark}
                                                          onChange={(e)=>onChangeField(e.target.value,'remark')} disabled={curChaObj.disabled} />
                        </div>:null}
                        {/* 校验 */}
                        {isSubmit==1?<>
                            {isEmpty(curChaObj.hasCertificate)?<div className={"color-err"}>
                                {Lang({id: 'QingXuanZeShiFouYouShangPinZhengShu', default: '请选择是否有商品证书'})}
                            </div>:null}
                            {curChaObj.hasCertificate === 1&&(!curChaObj.goodsCertificateList || curChaObj.goodsCertificateList.length ===0 )?<div className={"color-err"}>
                                {Lang({id: 'NinShangWeiXuanZeZhengShu', default: '您尚未选择证书'})}
                            </div>:null}
                            {curChaObj.hasCertificate === 0&&isEmpty(curChaObj.remark)?<div className={"color-err"}>
                                {Lang({id: 'QingTianXieWuZhengShuShuoMing', default: '请填写无证书说明'})}
                            </div>:null}
                        </>:null}
                    </div>)}
                {/* 贴纸模板 start */}
                {renderRow(Lang({id: 'TieZhiMoBan', default: '贴纸模板'}),required,
                        <div>
                            <StickerTemplateSelector key={"stickerCode_tem_"+inx}
                                                     source={curChaObj.stickerTemplateList}
                                                     newStickerList={curChaObj.newStickerList}
                                                     currentItem={curChaObj.stickerItem}
                                                     onSelectBack={(data)=>onChangeField(data,'stickerItem')}
                                                     sku={curChaObj} />
                        {/* 校验 */}
                        {isSubmit==1&&required&&!curChaObj.stickerCode?<div className={"color-err"}>
                            {Lang({id: 'XuanZeTieZhiMoBan', default: '选择贴纸模板'})}
                        </div>:null}
                    </div>)}
                {/* 贴纸品名 */}
                {renderRow(Lang({id: 'TieZhiPinMing', default: '贴纸品名'}),required,
                    isEdit?<div>
                                <TextArea placeholder={Lang({id: 'TieZhiPinMing', default: '贴纸品名'})}
                                          // defaultValue={curChaObj.nameRu}
                                          value={curChaObj.nameRu}
                                          onChange={(e)=>onChangeField(e.target.value,'nameRu')}
                                          disabled={curChaObj.disabled} />

                        {/* 校验 */}
                        {isSubmit==1&&required&&isEmpty(curChaObj.nameRu)?<div className={"color-err"}>
                            {Lang({id: 'SheZhiTieZhiPinPai', default: '设置贴纸品名'})}
                        </div>:null}
                    </div>:curChaObj.nameRu)}
                {/* 商品描述 扩展复制粘贴*/}
                {renderRow(Lang({id: 'HaiGuanShangPinBiaoMiaoShu', default: '海关商品表描述'}),false,
                    isEdit?<div>
                               <TextArea placeholder={Lang({id: 'HaiGuanShangPinBiaoMiaoShu', default: '海关商品表描述'})}
                                         // defaultValue={curChaObj.goodsDesc}
                                         value={curChaObj.goodsDesc}
                                         onChange={(e)=>onChangeField(e.target.value,'goodsDesc')}
                                         disabled={curChaObj.disabled} />
                    </div>:curChaObj.goodsDesc)}
                {/* 商品描述 end*/}
                {/* 修改说明*/}
                {renderRow(Lang({id: 'XiuGaiShuoMing', default: '修改说明'}),false,
                    isEdit?<div className={"flex-item"}>

                                <UploadImage // size={size}
                                             accept={'.gif,.jpg,.peg,.bmp,.png'}
                                             placeholder={Lang({id: 'JieTuShuoMing', default: '截图说明'})}
                                             onChange={(file)=>onChangeField(file,'file')}
                                             maxCount={1}
                                             // styleUpload={item.styleUpload}
                                             // styleName={item.styleName}
                                />
                            <div className={"flex-1"}>
                               <TextArea placeholder={Lang({id: 'QingShuRuMiaoShuBenCiYaoX', default: '请输入描述本次要修改的贴纸内容'})}
                                         value={curChaObj.remark}
                                         rows={4}
                                         style={{padding: '8px 11px'}}
                                         onChange={(e)=>onChangeField(e.target.value,'remark')}
                                         disabled={curChaObj.disabled} />
                            </div>

                    </div>:curChaObj.goodsDesc)}
                {/* 修改说明 end*/}
            </div>
        </div>
    </div>);
};

export default OneItem;